import { useAuth0 } from '@auth0/auth0-react'
import { useTranslation } from 'react-i18next'
import Button from '@mui/material/Button'
import LogoutIcon from '@mui/icons-material/Logout'

const baseButtonSx = {
  padding: '8px 16px',
  paddingTop: '11px',
  paddingBottom: '11px',
  borderRadius: '9999px',
  border: '1px solid #20C9FF',
  backgroundColor: 'transparent',
  color: '#ffffff',
  textDecoration: 'none',
  fontFamily: 'GothamBold, sans-serif',
  fontWeight: 500,
  fontStyle: 'normal',
  fontSize: '12px',
  lineHeight: '1',
  letterSpacing: '0.05em',
  textTransform: 'uppercase',
  fontVariantLigatures: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '6px',
  '&:hover': {
    backgroundColor: '#ffffff',
    color: '#0A93D2',
    border: '1px solid #ffffff'
  },
  '& .MuiButton-endIcon': {
    margin: 0
  },
  '& .MuiButton-startIcon': {
    margin: 0
  }
}

export default function LogoutButton({ sx = {} }) {
  const { t } = useTranslation()
  const { logout } = useAuth0()

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={() => logout({ logoutParams: { returnTo: window.origin } })}
      endIcon={<LogoutIcon />}
      sx={{
        ...baseButtonSx,
        minWidth: '130px',
        ...sx
      }}
    >
      {t('logout.text')}
    </Button>
  )
}